import api from "../../client";
import { CreateTagPayload, TagDetailResponseData } from "../../types/tag";

export const createTagRequest = async (
  payload: CreateTagPayload,
): Promise<TagDetailResponseData> => {
  const { data } = await api.post<TagDetailResponseData>(`/tag`, payload);

  return data;
};
